import React from 'react';
import {ContentTemplate, TitleHeader} from 'web-library';
import {useTranslation} from 'react-i18next';
import CompleteProfileDetailsForm
  from '../../modules/profile/components/CompleteProfileDetailsForm';

const ProfileDetail = () => {
  const {t} = useTranslation();
  return (
      <>
        <TitleHeader
            title={t('components->>CompleteProfileDetails.Coordinator Profile')}
        />

        <ContentTemplate>
          <CompleteProfileDetailsForm/>
        </ContentTemplate>
      </>
  );
};

export default ProfileDetail;
